/** Shared conversions used by DataViz generators and data helpers. */
export const toNumber = (value: unknown): number | undefined => {
  if (typeof value !== 'number' && typeof value !== 'string') return undefined;
  if (typeof value === 'string' && value.trim() === '') return undefined;
  const number = Number(value);
  return Number.isFinite(number) ? number : undefined;
};

export const toNumberTimestamp = (value: unknown): number | undefined => {
  const time = value instanceof Date ? value.getTime()
    : typeof value === 'number' ? value
    : typeof value === 'string' && /^\d{4}-\d{2}-\d{2}(?:T.*)?$/.test(value) ? Date.parse(value) : NaN;
  return Number.isFinite(time) && Math.abs(time) <= 8.64e15 ? time : undefined;
};

export const tickKey = (value: unknown): string => {
  return String(value instanceof Date ? value.getTime() : value);
};
